import Chartkick from 'chartkick'
import Chart from 'chart.js'

window.Chartkick = Chartkick
Chartkick.addAdapter(Chart)
Chartkick.options = {
  points: false,
  curve: false,
  colors: ['#21689d', 'rgba(127, 127, 127, 0.5)'],
  library: {
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          stepSize: 2,
          tooltipFormat: 'll'
        }
      }],
      yAxes: [{
        ticks: {
          stepSize: 5
        }
      }]
    }
  }
}
